// @flow
import type { TabItem } from "./index";

/**
 * TabItems relevant for displaying rugby markets
 *
 * @ignore
 */

const RugbyTabItems: [TabItem] = [
  {
    index: 0,
    title: "match",
    filteringType: "match",
    displayByCategoryOrder: false,
    categories: [
      "match result 2 way",
      "winning margin undefined home",
      "winning margin undefined away",
      "match handicap 2 way",
      "total points o/u",
      "tryscorer first",
      "player undefined total tries",
      "half time full time inc draws",
      "team to score 1st",
      "first score type",
      "first score of the time",
      "first score of the game",
      "race to x points",
      "race to x tries",
      "team to score last",
      "last score type",
      "last score type team",
      "both halves win",
      "half highest scoring",
      "winning margin undefined both halves away",
      "winning margin undefined both halves home",
      "winning margin undefined either half away",
      "winning margin undefined either half home",
      "red card player",
      "match handicap both halves 2 way",
      "match handicap either half 2 way",
      "match result both halves",
      "match result either half",
      "team to score first 1st half",
      "team to score first both halves",
      "team to score first either half",
      "team to score first try 2 way 1st half",
      "team to score first try 2 way both halves",
      "team to score first try 2 way either half",
      "team to score last 1st half",
      "team to score last 2nd half",
      "team to score last both halves",
      "team to score last either half",
      "team to score lasy try 2nd half",
      "team to score last try both halves",
      "team to score last try either half",
      "match result 2 way inc et",
      "handicap 2 way inc et"
    ],
  },
  {
    index: 1,
    title: "tries",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["tries", "tryscorer", "try"],
  },
  {
    index: 2,
    title: "points",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["points", "point", "race to x tries both halves"],
  },
  {
    index: 3,
    title: "half",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["half"],
  },
];

export { RugbyTabItems };



// WEBPACK FOOTER //
// ./src/model/rugby.js